import React from 'react';

const ProductSkeleton = () => {
    return (
        <div className="bg-card rounded-xl sm:rounded-2xl overflow-hidden border border-border">
            <div className="aspect-[3/4] bg-muted animate-pulse" />
            <div className="p-3 sm:p-6 space-y-3">
                <div className="h-3 bg-muted rounded animate-pulse w-1/3" />
                <div className="h-5 bg-muted rounded animate-pulse w-3/4" />
                <div className="h-3 bg-muted rounded animate-pulse w-full" />
                <div className="h-3 bg-muted rounded animate-pulse w-2/3" />
                <div className="flex justify-between items-center pt-2">
                    <div className="h-6 bg-muted rounded animate-pulse w-1/4" />
                    <div className="h-9 bg-muted rounded-lg animate-pulse w-1/3" />
                </div>
            </div>
        </div>
    );
};

export default ProductSkeleton;